import { render, staticRenderFns } from "./SuggestedEmployees.vue?vue&type=template&id=4a77169f&scoped=true&"
import script from "./SuggestedEmployees.vue?vue&type=script&lang=js&"
export * from "./SuggestedEmployees.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedEmployees.vue?vue&type=style&index=0&id=4a77169f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77169f",
  null
  
)

export default component.exports